<template>
  <div class="login-box-etiqueta">
    <div
      class="login-box-body-etiqueta"
      style="padding: 0px !important; margin-top: -20px !important"
    >
      <form>
        <div class="row-etiqueta">
          <div
            class="col-xs-6-etiqueta"
            style="padding-left: 5px; padding-right: 5px"
          >
            <div class="form-group-etiqueta">
              <img
                v-if="logo"
                :src="logo"
                alt="Logo Cliente"
                style="width: 65px; height: 65px; object-fit: contain"
                @error="
                  $event.target.src =
                    'https://cdn.multpex.com.br/logos/logo-acciona.png'
                "
              />
              <img
                v-else
                src="https://cdn.multpex.com.br/logos/logo-acciona.png"
                alt="Logo Acciona"
                style="width: 65px; height: 65px; object-fit: contain"
              />
              <p style="text-align: center; font-size: 17px; margin-top: -5px">
                <strong>{{ prodDetail.codigo_produto }}</strong>
              </p>
              <p style="text-align: justify; font-size: 10px; margin-top: -5px">
                {{ prodDetail.descricao_do_produto }}
              </p>
              <p style="text-align: center; font-size: 10px; margin-top: -5px">
                {{ prodDetail.unidade_de_medida }}
              </p>
            </div>
          </div>
          <div
            class="col-xs-6-etiqueta"
            style="padding-left: 5px; padding-right: 5px"
          >
            <div class="form-group-etiqueta">
              <img
                v-if="logo"
                :src="logo"
                alt="Logo Cliente"
                style="width: 65px; height: 65px; object-fit: contain"
                @error="
                  $event.target.src =
                    'https://cdn.multpex.com.br/logos/logo-acciona.png'
                "
              />
              <img
                v-else
                src="https://cdn.multpex.com.br/logos/logo-acciona.png"
                alt="Logo Acciona"
                style="width: 65px; height: 65px; object-fit: contain"
              />
              <p style="text-align: center; font-size: 17px; margin-top: -5px">
                <strong>{{ prodDetail.codigo_produto }}</strong>
              </p>
              <p style="text-align: justify; font-size: 10px; margin-top: -5px">
                {{ prodDetail.descricao_do_produto }}
              </p>
              <p style="text-align: center; font-size: 10px; margin-top: -5px">
                {{ prodDetail.unidade_de_medida }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();

    const logo = computed(() => {
      const logos = store.state.autenticacao.logo;
      console.log("LOGOS IMPRESSÃO ETIQUETA", logos);
      return logos ? logos.logoImpressao || logos.logo : null;
    });

    const prodDetail = ref({
      codigo_produto: route.query.codigo || "",
      descricao_do_produto: route.query.descricao || "",
      unidade_de_medida: route.query.unidade || "",
    });

    onMounted(() => {
      store.dispatch("pdt/hiddenHeader", false);
      setTimeout(() => {}, 500);
    });

    return {
      prodDetail,
      logo,
    };
  },
};
</script>

<style>
/* AdminLTE .login-box */
.login-box-etiqueta {
  width: 50%;
  margin: 7% auto;
}

/* AdminLTE .login-box-body */
.login-box-body-etiqueta {
  background: #fff;
  padding: 20px;
  border-top: 0;
  color: #000000;
}

/* Bootstrap .row */
.row-etiqueta {
  margin-right: -15px;
  margin-left: -13px;
}
.row-etiqueta:before,
.row-etiqueta:after {
  display: table;
  content: " ";
}
.row-etiqueta:after {
  clear: both;
}

/* Bootstrap .col-xs-6 */
.col-xs-6-etiqueta {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 50%;
  box-sizing: border-box;
}

/* Bootstrap .form-group */
.form-group-etiqueta {
  margin-bottom: 15px;
}

@media (max-width: 768px) {
  .login-box-etiqueta {
    width: 90%;
    margin-top: 20px;
  }
}
</style>
